// extracted by mini-css-extract-plugin
module.exports = {"grid":"Grid_grid__1wg67","row":"Grid_row__3tnTH","start":"Grid_start__RCMJh","col":"Grid_col__24W5M"};